import { render, staticRenderFns } from "./serveCompanyDetailSecond.vue?vue&type=template&id=611e1adc&scoped=true&"
import script from "./serveCompanyDetailSecond.vue?vue&type=script&lang=js&"
export * from "./serveCompanyDetailSecond.vue?vue&type=script&lang=js&"
import style0 from "./serveCompanyDetailSecond.vue?vue&type=style&index=0&id=611e1adc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611e1adc",
  null
  
)

export default component.exports